module.exports = __webpack_public_path__ + "img/bgBolden.822702aa.svg";